import {
    getAllBySelector,
    getBySelector,
    getValueBySelector,
    hideElementsBySelector, removeElementsBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {
    addLayer,
    getActiveLayers,
    getBookmarkPresentationsByID, getLayerByName,
    removeAllActiveLayers
} from "@/helpers/ol/ol-layer-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper";
import {transform} from "ol/proj";
import {resetViewRotation, viewFit} from "@/helpers/ol/ol-view";
import {Point} from "ol/geom";
import {addLayerActive} from "@/helpers/ol/ol-layer-active-helper";
import {
    deleteUserSession,
    postSession,
    postUserSession,
    setSessionDefault
} from "@/http/services/http-services-session";
import {showNotification} from "@/helpers/notification-helper";
import {initPopper} from "@/modules/popper";
import {disableCesium, getCesiumScene, isCesiumEnabled} from "@/modules/cesium/cesium";
import {enableCesium} from "@/helpers/cesium/cesium-helper";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {removeBackgroundLayer} from "@/modules/ol/ol-background-switcher";
import {clickCheckbox} from "@/helpers/layer-menu-group-merged-helper.js";
import {addTemporaryLayer, addTemporaryLayerService} from "@/helpers/layer/temporary/temporary-layer-helper.js";

let userSession

export function getUserSessionByID(id) {
    return getBookmarkSession().find(session => session.ID === parseInt(id))
}

export function getUserSession() {
    return userSession
}

export function getActiveSession() {
    if(userSession) {
        return userSession
    }
    return getDefaultSession()
}

export function getDefaultSession() {
    const sessions = getBookmarkSession()

    if(window.urlParamsObject.x) {
        return undefined
    }

    if(sessions) {
        const defaultSession = sessions.find(session => session.DefaultActive === 1)
        if(defaultSession) {
            userSession = defaultSession
            return defaultSession
        }
    }
    return undefined
}

export function getBookmarkSession() {
    return window.userSessions.filter(userSession => userSession.BookmarkID === window.websiteID)
}

export function activateUserSessionByID(id) {

    getBySelector('#layer-active').innerHTML = ''

    userSession = getUserSessionByID(id)

    console.log(userSession)

    if(userSession.Mode !== 1) {
        if(getBySelector('#iptZoomToUserSession').checked) {
            const extent = transform([Number(userSession.Y), Number(userSession.X)], 'EPSG:28992', getViewProjectionName())
            viewFit(new Point(extent), undefined, userSession.Zoom, 0)
        }
    }

    removeBackgroundLayer()
    userSession.user_session_bookmark_presentations.map((userSessionBookmarkPresentation) => {
        const isBackgroundLayer = window.settings.backgroundLayers.find(layer => layer.BookmarkPresentationID === userSessionBookmarkPresentation.BookmarkPresentationID)
        if (isBackgroundLayer) {
            removeAllActiveLayers()
        }
    })

    userSession.user_session_bookmark_presentations.map((userSessionBookmarkPresentation) => {

        if(userSessionBookmarkPresentation.ServiceType) {
            addTemporaryLayerService(userSessionBookmarkPresentation.ServiceType, userSessionBookmarkPresentation.ServiceUrl, userSessionBookmarkPresentation.ServiceLayer, undefined, undefined, userSessionBookmarkPresentation)
        } else {
            const isBackgroundLayer = window.settings.backgroundLayers.find(layer => layer.BookmarkPresentationID === userSessionBookmarkPresentation.BookmarkPresentationID)
            if(!isBackgroundLayer) {
                let checked = false
                if (userSessionBookmarkPresentation.Checked === 1) {
                    checked = true
                    addLayer(userSessionBookmarkPresentation.BookmarkPresentationID, checked)
                }

                const selector = getBySelector('layer-menu layer-menu-group-item[data-id="' + userSessionBookmarkPresentation.BookmarkPresentationID + '"]')
                if(selector) {
                    const selectorMerged = selector.closest('layer-menu-group').children[0]
                    if(selectorMerged.localName === 'layer-menu-group-merged') {
                        const selectorMergedInput = selectorMerged.querySelector('input')
                        const dataset = selectorMerged.dataset
                        selectorMergedInput.checked = true

                        clickCheckbox(selectorMergedInput, dataset.label, dataset.catalog, dataset.depth, dataset.key)
                    }
                }

                addLayerActive(userSessionBookmarkPresentation.BookmarkPresentationID, '', checked)
            } else {

                addLayer(userSessionBookmarkPresentation.BookmarkPresentationID, true)

                const layerLoaded = layersLoaded.find(layer => layer.BookmarkPresentationID === userSessionBookmarkPresentation.BookmarkPresentationID)
                if(layerLoaded.BookmarkGroupID) {
                    window.activeBookmarkGroupdID = layerLoaded.BookmarkGroupID
                } else {
                    window.activeBookmarkPresentationID = userSessionBookmarkPresentation.BookmarkPresentationID
                }
            }
        }
    })

    if(userSession.Mode === 1) {
        enableCesium(userSession)
    } else {
        disableCesium()
        setTimeout(() => {
            resetViewRotation()
        }, 1000)
    }

    getBySelector('#spnActiveSession').innerHTML = userSession.Name
    getBySelector('#divActiveSessionButton').innerHTML = `<bookmark-user-session-update-button data-id="${userSession.ID}"></bookmark-user-session-update-button>`
    showElementsBySelector('#divActiveSession')
}

export function disableUserSessionByID(id, type) {
    userSession = undefined
    hideElementsBySelector('#divActiveSession')

    if (type !== 'remove') {
        showNotification('De bookmark is gestopt')
    }

    // removeAllActiveLayers()
}

export function initUserSessions() {

    let innerHTML = `
    <div class="card m-3 bg-lighter" style="border-radius: 10px;">
        <div class="card-header font-weight-bold p-2">
             <span class="fa fa-bookmark navbar-icon" style="font-size:15px"></span>
             Bookmarks
             <button class="ml-1 btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                <span class="fa fa-times"></span>
             </button>
             <bookmark-user-session-add-button></bookmark-user-session-add-button>
        </div>
        <div class="card-body p-2">
             <label class="switcher">
                <span class="switcher-label w-100" style="margin-top:1px">
                    <i class="fa fa-expand"></i> Inzoomen naar opgeslagen locatie van de bookmark
                </span>
                <input id="iptZoomToUserSession" type="checkbox" class="switcher-input">
                <span class="switcher-indicator">
                  <span class="switcher-yes">
                    <span class="fa fa-draw-polygon"></span>
                  </span>
                  <span class="switcher-no">
                    <span class="fa fa-times"></span>
                  </span>
                </span>
              </label>
              
              <div id="divUserSessions">
`

    const defaultSession = getDefaultSession()
    getBookmarkSession().map((session, key) => {
        innerHTML += generateUserSessionItem(defaultSession, session, key)
    })

    innerHTML += `
            </div>
            </div>
         </div>
            `

    getBySelector('bookmark-session').innerHTML = innerHTML

    initPopper()
}

export function updateSession(id) {

    let userSession = getUserSessionByID(id)
    userSession = getActiveUserSessionObject(userSession)

    postSession(userSession.ID, userSession).then(result => {
        //// console.log(result)
        showNotification('De bookmark is opgeslagen', '', 'success')
    })
}

export function getActiveUserSessionObject(userSession) {

    userSession.BookmarkID = window.websiteID
    userSession.user_session_bookmark_presentations = []

    if(isCesiumEnabled()) {
        const camera = getCesiumScene().camera
        const position = camera.position
        userSession.X = position.x
        userSession.Y = position.y
        userSession.Zoom =  position.z
        userSession.Pitch = camera.pitch
        userSession.Roll = camera.roll
        userSession.Heading = camera.heading
        userSession.Mode = 1
    } else {
        let center = window.map.getView().getCenter()
        center = new Point(center).transform( getViewProjectionName(), 'EPSG:28992')
        userSession.X = center.getCoordinates()[1]
        userSession.Y = center.getCoordinates()[0]
        userSession.Zoom = window.map.getView().getZoom()
        userSession.Mode = 0
    }

    let layer

    getAllBySelector('layer-menu-active-item').forEach(element => {

        const activeLayer = element.dataset.id
        let checked = 0
        if(element.querySelector('input').checked) {
            checked = 1
        }

        const bookmarkPresentation = getBookmarkPresentationsByID(activeLayer)
        let domainID = ''
        if(bookmarkPresentation) {
            domainID = bookmarkPresentation.DomainID
        }

        layer = getLayerByName(activeLayer)
        userSession.user_session_bookmark_presentations.push({
            BookmarkPresentationID: activeLayer,
            Checked: checked,
            ZIndex: layer.getZIndex(),
            Opacity: layer.getOpacity() * 10,
            DomainID: domainID
        })
    })

    getAllBySelector('layer-menu-active layer-menu-group-merged').forEach(element => {
        const mergedElement = getBySelector('layer-menu layer-menu-group-merged[data-depth="' + element.dataset.depth + '"][data-key="' + element.dataset.key + '"]')
        mergedElement.closest('layer-menu-group').querySelectorAll('input').forEach( input => {
            layer = getLayerByName(input.value)
            const bookmarkPresentation = getBookmarkPresentationsByID(input.value)
            let domainID = ''
            if(bookmarkPresentation) {
                domainID = bookmarkPresentation.DomainID
            }
            let checked = 0
            if(element.querySelector('input').checked) {
                checked = 1
            }

            if(layer) {
                userSession.user_session_bookmark_presentations.push({
                    BookmarkPresentationID: input.value,
                    Checked: checked,
                    ZIndex: layer.getZIndex(),
                    Opacity: layer.getOpacity() * 10,
                    DomainID: domainID
                })
            }
        })
    })

    if(window.activeBookmarkGroupdID) {
        layersLoaded.filter(layer => layer.BookmarkGroupID === window.activeBookmarkGroupdID).map((layerLoaded) => {
            layer = getLayerByName(layerLoaded.BookmarkPresentationID)

            // Add background layer
            if(layer) {
                userSession.user_session_bookmark_presentations.push({
                    BookmarkPresentationID: layerLoaded.BookmarkPresentationID,
                    Checked: 1,
                    ZIndex: layer.getZIndex(),
                    Opacity: layer.getOpacity() * 10,
                    DomainID: layerLoaded.DomainID
                })
            }
        })
    } else {
        // Add background layer
        layer = getLayerByName(window.activeBookmarkPresentationID)

        if(layer) {
            let opacity = layer.getOpacity() * 10
            if(!opacity) {
                opacity = 10
            }

            const bookmarkPresentation = layersLoaded.find(layer => layer.BookmarkPresentationID === parseInt(window.activeBookmarkPresentationID))
            let domainID = ''
            if(bookmarkPresentation) {
                domainID = bookmarkPresentation.DomainID
            }

            userSession.user_session_bookmark_presentations.push({
                BookmarkPresentationID: window.activeBookmarkPresentationID,
                Checked: 1,
                ZIndex: layer.getZIndex(),
                Opacity: opacity,
                DomainID: domainID
            })
        }
    }

    return userSession
}

export function updateSessionDefault(id, type = 'enable') {
    setSessionDefault(id, type).then(result => {

        if(type === 'enable') {
            showNotification('<b>' + result.Name + '</b> is nu de standaard bookmark', '', 'success')
        } else {
            showNotification('Er zal geen standaard bookmark meer opgestart worden', '', 'success')
        }

    })
}

export function removeUserSession(id) {
    disableUserSessionByID(id, 'remove');
    deleteUserSession(id).then(result => {
        window.userSessions = window.userSessions.filter(userSession => userSession.ID !== parseInt(id))
        userSession = undefined
        showNotification('De bookmark is verwijderd', '', 'success')
    })
}

export function createUserSession(name) {
    userSession = getActiveUserSessionObject({})
    userSession.Name = name
    postUserSession(userSession).then(result => {
        return result.json()
    }).then((result) => {
        let innerHtml = generateUserSessionItem(result, result, window.userSessions.length - 1)
        getBySelector('#divUserSessions').innerHTML += innerHtml
        window.userSessions.push(result)
        activateUserSessionByID(result.ID)
    })
}

export function generateUserSessionItem(defaultSession, session, key) {
    let innerHTML = ''
    let background = ''
    let active = ''
    if(defaultSession && defaultSession.ID === session.ID) {
        background = 'bg-light'
        active = true
    }
    innerHTML += `   
           <div class="card ml-0 mr-0 mt-2 card-user-session ` + background + `" data-tab-name="Info">
                <div class="card-header p-2">
                   <bookmark-user-session-start-button data-active="` + active + `" data-id="` + session.ID + `"></bookmark-user-session-start-button>
                    <a href="#" class="text-dark accordion-header" data-bs-target="#collapseSession` + key + `" data-bs-toggle="collapse" aria-expanded="false">
                    <bookmark-user-session-default-button data-is-default-active="` + session.DefaultActive + `" data-id="` + session.ID + `"></bookmark-user-session-default-button>`
        + session.Name + `
                    </a>  
                    <div class="float-right buttons-user-session">
                        <bookmark-user-session-update-name-button data-id="` + session.ID + `"></bookmark-user-session-update-name-button>
                        <bookmark-user-session-remove-button data-id="` + session.ID + `"></bookmark-user-session-remove-button>
                       
                    </div> 
                </div>`
    innerHTML += `</div>`
    return innerHTML
}
